/**
 * QuestionCard Component
 * Displays a single quiz question with styling
 */

import React from 'react';
import { Box, Typography } from '@mui/material';
import type { Question } from '../../types';

interface QuestionCardProps {
  question: Question;
  currentQuestionIndex: number;
  totalQuestions: number;
}

function QuestionCard({ question }: QuestionCardProps): JSX.Element {
  return (
    <Box className="cla-quiz-question" data-quiz-question-id={question.id} data-quiz-question-type={question.type} sx={{ mb: 3 }}>
      <Typography
        className="cla-quiz-question-label"
        variant="h5"
        sx={{
          fontWeight: 700,
          color: '#1C3654',
          lineHeight: 1.35,
          fontSize: { xs: '1.25rem', sm: '1.5rem' },
        }}
      >
        {question.text}
      </Typography>
    </Box>
  );
}

export default QuestionCard;
